import MapListDialog from './dialogs/MapListDialog';

function MapSelection() {
  return <MapListDialog isOpen />
}

export default MapSelection;
